import { faqItems } from '@/mocks/home';

export default function FAQSection() {
  return (
    <section id="faq" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-8">
          常见问题
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {faqItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">Q</span>
                {item.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                <span className="text-secondary-500 font-semibold mr-2">A</span>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}